import { Logo } from "@/components/common/Logo";
import { useAuth } from "@/context/AuthContext";

const COPY = {
  pending: {
    eyebrow: "Richiesta ricevuta",
    title: (n) => <>Grazie, <em>{n}</em>.</>,
    text: "La tua richiesta di iscrizione è in attesa di approvazione. Il nostro team sta verificando i dati con cura: riceverai un'email non appena il tuo accesso sarà attivo.",
  },
  rejected: {
    eyebrow: "Iscrizione non approvata",
    title: () => "La tua richiesta non è stata approvata.",
    text: "Per qualsiasi chiarimento puoi scriverci rispondendo all'email ricevuta o contattare il tuo referente Skin Lovers.",
  },
  suspended: {
    eyebrow: "Accesso sospeso",
    title: () => "Il tuo accesso è momentaneamente sospeso.",
    text: "Per riattivarlo contatta il tuo referente Skin Lovers: saremo felici di aiutarti.",
  },
};

export default function AccountStatus() {
  const { user, logout, refreshMe } = useAuth();
  const c = user.center || {};
  const copy = COPY[c.status] || COPY.pending;
  return (
    <div className="min-h-screen flex flex-col">
      <div className="px-6 sm:px-12 pt-8"><Logo /></div>
      <div data-testid={`account-status-${c.status}`} className="flex-1 max-w-xl w-full mx-auto px-6 py-16 flex flex-col justify-center animate-fade-up">
        <span className="h-px w-12 bg-gold mb-10" />
        <p className="eyebrow mb-5">{copy.eyebrow}</p>
        <h1 className="text-4xl sm:text-5xl font-light leading-tight">{copy.title(c.center_name)}</h1>
        <p className="mt-6 text-base text-warm-text leading-relaxed">{copy.text}</p>
        {c.status === "rejected" && c.rejection_reason && (
          <p data-testid="rejection-reason" className="mt-6 lux-card p-5 text-sm leading-relaxed">{c.rejection_reason}</p>
        )}
        <div className="mt-12 flex flex-wrap gap-4">
          {c.status === "pending" && <button data-testid="status-refresh-btn" onClick={refreshMe} className="btn-ghost">Verifica di nuovo</button>}
          <button data-testid="status-logout-btn" onClick={logout} className="btn-link self-center">Esci</button>
        </div>
      </div>
    </div>
  );
}
